import React, { Component } from 'react';
import { userActions } from '../acciones/userActions';
import { connect } from 'react-redux';
import ValidacionCampo from 'react-comun-seps/lib/components/ValidacionCampo';
import MensajeAlertaInline from 'react-comun-seps/lib/components/MensajeAlertaInline';
import './login.css';
import { Captcha } from 'reactjs-captcha'; 
import { Link } from 'react-router-dom';
import { ApiRest } from 'react-comun-seps/lib/api/ApiRest';
import EXITO from 'react-comun-seps/lib/constantes/tipoAlerta';
import { CAPTCHA_HOST } from 'node-constantes-seps';

var I18n = require('react-redux-i18n').I18n;

class RecuperarclavePage extends Component {

    constructor(props) {
        super(props);
        // reset login status
        this.props.dispatch(userActions.logout());

        this.state = {
            usuario: '',
            correoelectronico: '',
            submitted: false,
            activador: false,
            errorCaptcha: false,
        };
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.activaralgo = this.activaralgo.bind(this);
        this.thecaptchaResponse = true;
    }

    activaralgo(valor = true) {
        return valor;
    }

    componentDidMount() {
        document.body.classList.add('login-body');
        this.activaralgo(true);
        this.setState({ estado: false });
    }

    componentWillUnmount() {
        document.body.classList.remove('login-body');
    }

    onChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onSubmit(e) {
        e.preventDefault();
        // the user-entered captcha code value to be validated at the backend side 
        let userEnteredCaptchaCode = this.captcha.getUserEnteredCaptchaCode(); 
        
        // the id of a captcha instance that the user tried to solve 
        let captchaId = this.captcha.getCaptchaId(); 
        let postData = { 
            userEnteredCaptchaCode: userEnteredCaptchaCode, 
            captchaId: captchaId 
        }; 
        let self = this; 
        //Validacion captcha
        ApiRest.post(`${window.location.protocol}//${window.location.hostname}:3030/app.php`,postData,{'Content-Type': 'application/json; charset=utf-8'})
        ApiRest.post(`${CAPTCHA_HOST}/app.php`,postData,{'Content-Type': 'application/json; charset=utf-8'})
        .then(resultado => {
            if(resultado.success){
                this.setState({ submitted: true });
                this.setState({ estado: true });
                const { usuario, correoelectronico } = this.state;
                const { dispatch } = this.props;
                if (usuario && correoelectronico) {
                    dispatch(userActions.validar(usuario, correoelectronico));
                }
            }else{
                this.setState({errorCaptcha: true});
                self.captcha.reloadImage(); 
            }
        });
    }

    render() {
        const { usuario, correoelectronico, submitted, estado } = this.state;
        const { alert } = this.props;
        let mostrarForm = (alert && alert.tipoMensaje===EXITO);
        return (
        <div className="pantallalogin">
            <div className="text-center logo-login">
                <img src="/assets/images/login/login.png" alt="SEPS"/>
            </div>
            <div className="card login-panel ui-fluid">
                <div className="login-panel-content">
                {submitted && alert && 
                        <MensajeAlertaInline tipoMensaje={alert.tipoMensaje} detalle={alert.detalle}/>
                }
                {mostrarForm && <div className="ui-g">
                    <div className="ui-g-3 text-left">
                        <img src="/assets/images/login/icon-login.svg" alt="Recuperar Clave" />
                    </div>
                    <div className="ui-g-9 text-right">
                        <h2 className="welcome-text">Reestrablecer contraseña</h2>                   
                    </div>
                    <form name="form" onSubmit={this.onSubmit}>
                        <div className={'ui-g-12 text-left' + (submitted && !usuario ? ' has-error' : '')}>
                            <label className="login-label" htmlFor="username">{I18n.t('app.usuario')}</label>
                            <div className="login-input">
                                <input type="text" className="ui-inputtext ui-widget ui-state-default ui-corner-all" name="usuario" value={usuario} onChange={this.onChange} />
                                {submitted && !usuario &&
                                    <ValidacionCampo mensaje = {I18n.t('formulario.campo_obligatorio')} />
                                }
                            </div>
                        </div>
                        <div className={'ui-g-12 text-left' + (submitted && !correoelectronico ? ' has-error' : '')}>
                            <label className="login-label" htmlFor="correoelectronico">Correo electrónico</label>
                            <div className="login-input">
                                <input type="text" className="ui-inputtext ui-widget ui-state-default ui-corner-all" name="correoelectronico" onChange={this.onChange} />
                                {submitted && !correoelectronico &&
                                    <ValidacionCampo mensaje = {I18n.t('formulario.campo_obligatorio')} />
                                }
                            </div>
                        </div>  

                        <div className={'ui-g-12 text-left' + (submitted && !usuario ? ' has-error' : '')}>
                            <label className="login-label" htmlFor="captcha">Verificador</label>
                            <div className="content-section implementation button-demo">
                                {this.state.errorCaptcha &&
                                    <ValidacionCampo mensaje = {I18n.t('formulario.error_captcha')} />
                                }
                                <Captcha captchaStyleName="scaCaptchaStyle" 
                                        ref={(captcha) => {this.captcha = captcha}} /> 
                                    <input className="ui-inputtext ui-widget ui-state-default ui-corner-all" id="scaCapthaRecuperarClave" type="text" /> 
                            </div>
                        </div> 
                                    
                         <div className="ui-g-12 ui-md-6 button-pane">
                            <button className="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" role="button" aria-disabled="false" disabled={estado}>
                                <span className="ui-button-text ui-c">Enviar</span>
                            </button>
                            </div> 
                        <div className="ui-g-12 ui-md-6 link-pane">
                            <Link to="/">Regresar</Link>
                        </div>
                    </form>
                </div>}
                {!mostrarForm && <div className="ui-g-12 ui-md-6 link-pane">
                    <Link to="/">Regresar</Link>
                </div>}
                </div>
            </div>
        </div>
        );
    }
}

function mapStateToProps(state) {
    const { alert } = state;
    return {
        alert
    };
}

const connectedRecuperarclavePage = connect(mapStateToProps)(RecuperarclavePage);
export { connectedRecuperarclavePage as RecuperarclavePage }; 